import React from 'react'
import PropTypes from 'prop-types'
import { Close } from '@material-ui/icons'
import { useHistory } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { Dialog, IconButton, makeStyles, Typography } from '@material-ui/core'

import { SUBMIT } from 'app/constants/button'
import { PaidPlanAccess } from 'app/auth/paidPlanAccess'
import themesConfig from 'app/fuse-configs/themesConfig'
import PaidPlanAccessBlock from 'app/auth/PaidPlanAccessBlock'
import { Routes } from 'app/services/routeService/routeService'

import GreyBox from 'app/components/GreyBox'
import {
  ExternalSourceCircleIcon,
  UserPlusCircleIcon,
  UsersPlusCircleIcon,
} from 'app/components/icons'

import OutlinedButtons from 'app/componentV4/Button/OutlinedButtons'

const useStyles = makeStyles((themes) => ({
  root: {
    '& .MuiDialog-paper': {
      padding: '3rem',
      maxWidth: '500px',
      [themes.breakpoints.up('md')]: {
        maxWidth: '800px',
      },
    },
  },
}))

const MenusAddSubscriber = ({ open, onClose, openOneByOne }) => {
  const classes = useStyles()
  const history = useHistory()

  const goToImportSubscriber = () => {
    history.push(Routes.importSubscriberV4())
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth={true}
      aria-labelledby="menus-add-subscriber"
      className={classes.root}
    >
      <div className="flex justify-end">
        <div className="absolute flex justify-center w-full pl-60 h-44">
          <Typography className="text-18 font-bold text-primary flex items-center">
            <FormattedMessage id="subscriber.add.dialog.title" />
          </Typography>
        </div>
        <IconButton className="" onClick={onClose}>
          <Close fontSize="small" />
        </IconButton>
      </div>

      <Typography className="text-18 text-grey-400 items-center px-24 text-center">
        <FormattedMessage id="subscriber.add.dialog.subTitle" />
      </Typography>

      <div className="mt-10 space-y-10 md:flex md:justify-between   md:space-y-0 md:divide-x md:divide-neutrals-200">
        <div className="space-y-5 md:w-1/3">
          <div className="flex justify-center mx-auto">
            <UserPlusCircleIcon
              color={themesConfig.default.colors.secondary}
              bgColor={themesConfig.default.colors['primary-200']}
              classes="w-auto"
            />
          </div>
          <div className="flex justify-center">
            <OutlinedButtons
              id="add-subscriber-one-by-one"
              variant="outlined"
              size="small"
              onClick={openOneByOne}
              className={classes.addSubscribersActionBtn}
              color={SUBMIT}
            >
              <FormattedMessage id="subscriber.table.addOneByOne" />
            </OutlinedButtons>
          </div>
        </div>
        <PaidPlanAccess
          freePlanComponent={
            <div className="flex items-center p-10">
              <GreyBox>
                <PaidPlanAccessBlock titleId="paidPlanRestriction.importCSV.description.text" />
              </GreyBox>
            </div>
          }
        >
          <div className="space-y-5 md:w-1/3">
            <div className="flex justify-center mx-auto">
              <UsersPlusCircleIcon
                color1={themesConfig.default.colors.secondary}
                color2={themesConfig.default.colors['secondary-200']}
                bgColor={themesConfig.default.colors['primary-200']}
                classes=""
              />
            </div>
            <div className="flex justify-center">
              <OutlinedButtons
                id="import-csv-btn"
                variant="outlined"
                size="small"
                onClick={goToImportSubscriber}
                className={classes.addSubscribersActionBtn}
                color={SUBMIT}
              >
                <FormattedMessage id="subscriber.table.import.csv" />
              </OutlinedButtons>
            </div>
          </div>
          <div className="space-y-5 md:w-1/3">
            <div className="flex justify-center mx-auto">
              <ExternalSourceCircleIcon
                color1={themesConfig.default.colors['secondary-200']}
                color2={themesConfig.default.colors.secondary}
                color3={themesConfig.default.colors['indian-red']}
                bgColor={themesConfig.default.colors['primary-200']}
                classes=""
              />
            </div>
            <div className="flex justify-center">
              <OutlinedButtons
                id="import-external-source-btn"
                variant="outlined"
                size="small"
                onClick={goToImportSubscriber}
                className={classes.addSubscribersActionBtn}
                color={SUBMIT}
              >
                <FormattedMessage id="subscribers.import.tabs.tab2.label" />
              </OutlinedButtons>
            </div>
          </div>
        </PaidPlanAccess>
      </div>
    </Dialog>
  )
}

MenusAddSubscriber.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  openOneByOne: PropTypes.func,
}

export default MenusAddSubscriber
